import React from 'react';

import { PageProps } from '../../../components/types/coretypes';
import { FWorkbenchShell } from '../workbench';

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from '@mui/material';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

import DatasetOutlinedIcon from '@mui/icons-material/DatasetOutlined';

import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';

import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';

import FactCheckIcon from '@mui/icons-material/FactCheck';

import InventoryIcon from '@mui/icons-material/Inventory';

import Inventory2Icon from '@mui/icons-material/Inventory2';

import {
  BieOnboardingWorkbenchTab,
  BieRecordId,
  IBieOnboardingValidationIssue,
  IBieOnboardingValidationRule,
  IBieOnboardingWorkbench,
  IBieOnboardingWorkbenchFilters,
  IBieOnboardingWorkbenchImport,
  IBieOnboardingWorkbenchState,
  emptyBieOnboardingWorkbenchFilters,
  emptyBieOnboardingWorkbenchState,
  getBieImportClassLabel,
} from './bieonboardingworkbench.models';

import {
  //BieOnboardingWorkbenchApi,
  //bieOnboardingWorkbenchApi,
  fetchBieOnboardingWorkbench,
  fetchBieOnboardingValidationIssues,
  fetchBieOnboardingValidationRules,
} from './bieonboardingworkbench.apis';

// import {
//   validateBieOnboardingWorkbook,
// } from './bieonboardingworkbook.apis';

import { BieOnboardingApiError } from './bieonboarding.api.error';

import BieOnboardingImportCard from './BieOnboardingImportCard';

import BieOnboardingIssueGrid from './BieOnboardingIssueGrid';

import BieOnboardingOverview from './BieOnboardingOverview';

import BieOnboardingRuleGrid from './BieOnboardingRuleGrid';

import BieOnboardingStatusChip from './BieOnboardingStatusChip';
import { validateBieOnboardingReview } from './bieonboardingreview.apis';

//import BieOnboardingWorkbenchStaging from './BieOnboardingWorkbenchStaging';
import BieOnboardingWorkbenchStaging, {
  IBieOnboardingStagedImportSummary,
  IBieOnboardingWorkbenchStagingData,
} from './BieOnboardingWorkbenchStaging';
import { reviewBieOnboardingWorkbook } from './bieonboardingworkbook.apis';
import { stageBieLoadSession } from './bieloadsession.apis';

// import {
//   reviewBieOnboardingWorkbook,
// } from './bieonboardingworkbook.apis';

/* ============================================================
 * Props
 * ============================================================
 */

const PAGE_LOAD_SESSION_MANAGER = 'bieonboardingsession';
const PAGE_LOAD_SESSION_WIZARD = 'bieonboardingwizard';
const PAGE_IMPORT_RECORDS = 'bieonboardingimport';
const PAGE_IMPORT_ITEM = 'bieonboardingimportitem';

export interface IBieOnboardingWorkbenchProps extends PageProps {
  loadSessionId?: BieRecordId;

  /**
   * Optional injectable API client.
   *
   * The default shared API client is used when omitted.
   */
  //api?: BieOnboardingWorkbenchApi;

  /**
   * Automatically loads the Workbench when mounted.
   *
   * Default: true
   */
  autoLoad?: boolean;

  /**
   * Optional page title.
   */
  //title?: string;

  /**
   * Optional navigation action.
   */
  onBack?: () => void;

  /**
   * Opens the staged records belonging to one Import.
   */
  onOpenImportRecords?: (
    importId: BieRecordId,
    data: IBieOnboardingWorkbenchImport
  ) => void;

  /**
   * Opens one staged Import Item.
   */
  onOpenImportItem?: (
    importItemId: BieRecordId,
    issue?: IBieOnboardingValidationIssue
  ) => void;

  /**
   * Pack 6 publication callback.
   *
   * The callback should perform publication and resolve after
   * the operation completes. The Workbench will then refresh.
   */
  onPublish?: (
    loadSessionId: BieRecordId,
    stamp: string
  ) => Promise<void> | void;

  /**
   * Called whenever a newly refreshed Workbench contract is
   * received.
   */
  onWorkbenchChange?: (workbench: IBieOnboardingWorkbench) => void;

  // // Framework propsa
  // title?: string; // = { stitle }
  // sconfig?: any; // = { ServiceConfig }
  // sdata?: any; //  = { SData }
  // rows?: any[]; //  = { cm }
  // data?: any; //  = { data }
  // actionSet?: any; //  = { actionSet }
  // [name: string]: any; //{...others }
}

/* ============================================================
 * Component state
 * ============================================================
 */

// interface IBieOnboardingWorkbenchComponentState {
//   // Existing state...

  
// }

interface IBieOnboardingWorkbenchComponentState
  extends IBieOnboardingWorkbenchState {
  issuesLoading: boolean;
  rulesLoading: boolean;
  publishing: boolean;

  validationDialogOpen: boolean;

  selectedImportId: BieRecordId | '';
  selectedIssueId: BieRecordId | '';
  selectedRuleId: BieRecordId | '';

  loadSessionId: BieRecordId;

  stagingReview:
  | IBieOnboardingWorkbenchStagingData
  | null;

  loadingStagingReview: boolean;
  refreshingStagingReview: boolean;

  stagingErrorMessage: string;

  staging: boolean;
}

/* ============================================================
 * Component
 * ============================================================
 */

/**
 * Main class component for the Pack 5 BIE Institutional
 * Onboarding Workbench.
 *
 * Coordinates:
 *
 * - Initial Workbench loading
 * - Overview dashboard
 * - Import worksheet cards
 * - Validation issue search and paging
 * - Validation rule catalogue
 * - Workbook validation and revalidation
 * - Pack 6 publication callback
 * - Navigation to staged records
 */
export default class BieOnboardingWorkbench extends React.Component<
  IBieOnboardingWorkbenchProps,
  IBieOnboardingWorkbenchComponentState
> {
  //private readonly api: BieOnboardingWorkbenchApi;

  private mounted = false;

  private workbenchRequestVersion = 0;
  private issueRequestVersion = 0;
  private ruleRequestVersion = 0;

  public constructor(props: IBieOnboardingWorkbenchProps) {
    super(props);

    //this.api = props.api; // || bieOnboardingWorkbenchApi;

    this.state = {
      ...emptyBieOnboardingWorkbenchState,

      issuesLoading: false,
      rulesLoading: false,
      publishing: false,

      validationDialogOpen: false,

      selectedImportId: '',
      selectedIssueId: '',
      selectedRuleId: '',

      loadSessionId: this.resolveLoadSessionId(props),

      stagingReview: null,
      loadingStagingReview: false,
      refreshingStagingReview: false,
      stagingErrorMessage: '',

      staging: false,
    };
  }

  public componentDidMount(): void {
    this.mounted = true;

    if (this.props.autoLoad !== false) {
      void this.loadWorkbench(true);
    }
  }

  public componentDidUpdate(previousProps: IBieOnboardingWorkbenchProps): void {
    if (
      String(this.resolveLoadSessionId(previousProps)) !==
      String(this.resolveLoadSessionId(this.props))
    ) {
      this.resetForLoadSessionChange(this.resolveLoadSessionId(this.props));

      void this.loadWorkbench(true);
    }
  }

  public componentWillUnmount(): void {
    this.mounted = false;

    /*
     * Invalidate outstanding requests so their responses are
     * ignored after unmounting.
     */
    this.workbenchRequestVersion += 1;
    this.issueRequestVersion += 1;
    this.ruleRequestVersion += 1;
  }

  public render(): React.ReactNode {
    const { workbench, loading, errorMessage } = this.state;

    return (
      <FWorkbenchShell
        //title={this.props.title || 'Institutional Onboarding Workbench'}
        title={'Institutional Onboarding Workbench'}
        subtitle={
          workbench
            ? `${workbench.loadSession.code} · ${workbench.loadSession.name}`
            : 'Review staged imports, validation issues and publication readiness.'
        }
        icon={<FactCheckOutlinedIcon />}
        loading={loading && !workbench}
        error={errorMessage}
        onBack={this.handleBack}
        onRefresh={this.handleRefreshWorkbench}
        actions={this.renderPrimaryWorkflowAction()}
      >
        <Stack spacing={2} sx={{ width: '100%' }}>
          {/* {this.renderPrimaryWorkflowAction()} */}
          {this.renderPageHeader()}
          {this.renderTabs()}
          {this.renderSelectedTab()}
          {this.renderValidationDialog()}
          {this.renderNotifications()}
        </Stack>
      </FWorkbenchShell>
    );
  }

  private resolveLoadSessionId(
    props: IBieOnboardingWorkbenchProps = this.props
  ): BieRecordId {
    return props.loadSessionId ?? props.params?.loadsessionid ?? '';
  }

  private readonly handleBack = (): void => {
    if (this.props.onBack) {
      this.props.onBack();
      return;
    }

    const origin = String(
      this.props.params?.workbenchorigin || PAGE_LOAD_SESSION_MANAGER
    );

    this.props.setPage(
      origin === PAGE_LOAD_SESSION_WIZARD
        ? PAGE_LOAD_SESSION_WIZARD
        : PAGE_LOAD_SESSION_MANAGER
    );
  };

  /* ==========================================================
   * Page header
   * ==========================================================
   */

  private renderPageHeader(): React.ReactNode {
    const { workbench, loading, refreshing, validating, publishing } =
      this.state;

    const busy = loading || refreshing || validating || publishing;

    return (
      <Paper
        variant="outlined"
        sx={{
          p: {
            xs: 1.5,
            sm: 2,
          },
        }}
      >
        <Stack
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          alignItems={{
            xs: 'stretch',
            sm: 'center',
          }}
          justifyContent="space-between"
          spacing={2}
        >
          <Stack
            direction="row"
            spacing={1.25}
            alignItems="center"
            sx={{
              minWidth: 0,
            }}
          >
            {this.props.onBack && (
              <Tooltip title="Back" arrow>
                <IconButton onClick={this.props.onBack} disabled={busy}>
                  <ArrowBackOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}

            <Box
              sx={{
                minWidth: 0,
              }}
            >
              <Typography variant="h5" fontWeight={700} noWrap>
                {/* {this.props.title || 'Institutional Onboarding Workbench'} */}
                {'Onboarding Review'}
              </Typography>

              <Typography variant="body2" color="text.secondary" noWrap>
                {workbench
                  ? `${workbench.loadSession.code} · ${
                      workbench.loadSession.name
                    }`
                  : 'Loading the selected Load Session'}
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent={{
              xs: 'space-between',
              sm: 'flex-end',
            }}
            spacing={1}
            useFlexGap
            flexWrap="wrap"
          >
            {workbench && (
              <>
                <BieOnboardingStatusChip
                  kind="LOAD_SESSION"
                  value={workbench.loadSession.stateCode}
                />

                <BieOnboardingStatusChip
                  kind="VALIDATION"
                  value={workbench.summary.validationStatus}
                />
              </>
            )}

            <Tooltip title="Refresh Workbench" arrow>
              <span>
                <IconButton
                  disabled={busy}
                  onClick={this.handleRefreshWorkbench}
                >
                  {refreshing ? (
                    <CircularProgress size={22} />
                  ) : (
                    <RefreshOutlinedIcon />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        </Stack>
      </Paper>
    );
  }

  /* ==========================================================
   * Primary Workflow Action
   * ==========================================================
   */

  private renderPrimaryWorkflowAction():React.ReactNode {
    const workbench = this.state.workbench;
    //console.log('workbench:',workbench);

    if (!workbench) {
      return null;
    }

    //console.log('workbench.valid:', JSON.stringify(workbench));

    if (workbench.actions.canStage) {
      return (
        <Button
          variant="contained"
          startIcon={
            this.state.staging
              ? <CircularProgress size={18} />
              : <InventoryIcon />
          }
          disabled={
            this.state.staging ||
            this.state.validating ||
            this.state.loading
          }
          onClick={this.handleCompleteStaging}
        >
          {this.state.staging
            ? 'Completing Staging...'
            : 'Complete Staging'}
        </Button>
      );
    }

    if (workbench.actions.canValidate) {
      return (
        <Button
          variant="contained"
          startIcon={
            this.state.validating
              ? <CircularProgress size={18} />
              : <FactCheckIcon />
          }
          disabled={
            this.state.validating ||
            this.state.staging ||
            this.state.loading
          }
          //onClick={this.handleValidate}
          onClick={this.handleOpenValidationDialog}
        >
          {this.state.validating
            ? 'Validating...'
            : 'Validate Workbook'}
        </Button>
      );
    }

    return null;
  }

  /* ==========================================================
   * Tabs
   * ==========================================================
   */

  private renderTabs(): React.ReactNode {
    const workbench = this.state.workbench;

    return (
      <Paper
        variant="outlined"
        sx={{
          overflow: 'hidden',
        }}
      >
        <Tabs
          value={this.state.selectedTab}
          onChange={this.handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            px: 1,

            '& .MuiTab-root': {
              minHeight: 56,
              fontWeight: 600,
            },
          }}
        >
          <Tab
            value="OVERVIEW"
            icon={<AssessmentOutlinedIcon />}
            iconPosition="start"
            label="Overview"
          />

          <Tab
            value="STAGING"
            icon={<AssessmentOutlinedIcon />}
            iconPosition="start"
            label="Staging & Resolution"
          />

          <Tab
            value="IMPORTS"
            icon={<DatasetOutlinedIcon />}
            iconPosition="start"
            label={
              workbench
                ? `Imports (${this.formatNumber(workbench.imports.length)})`
                : 'Imports'
            }
          />

          <Tab
            value="ISSUES"
            icon={<FactCheckOutlinedIcon />}
            iconPosition="start"
            label={
              workbench
                ? `Issues (${this.formatNumber(
                    workbench.summary.issues.total
                  )})`
                : 'Issues'
            }
          />

          <Tab
            value="RULES"
            icon={<RuleOutlinedIcon />}
            iconPosition="start"
            label="Validation Rules"
          />
        </Tabs>
      </Paper>
    );
  }

  /* ==========================================================
   * Selected tab
   * ==========================================================
   */

  private renderSelectedTab(): React.ReactNode {
    switch (this.state.selectedTab) {
      case 'IMPORTS':
        return this.renderImportsTab();

      case 'ISSUES':
        return this.renderIssuesTab();

      case 'RULES':
        return this.renderRulesTab();

      case 'STAGING':
        return this.renderStagingTab();

      case 'OVERVIEW':
      default:
        return this.renderOverviewTab();
    }
  }

  /* ==========================================================
   * Overview tab
   * ==========================================================
   */

  private renderOverviewTab(): React.ReactNode {
    return (
      <BieOnboardingOverview
        workbench={this.state.workbench}
        loading={this.state.loading}
        refreshing={this.state.refreshing}
        validating={this.state.validating}
        publishing={this.state.publishing}
        errorMessage={this.state.errorMessage}
        onRefresh={this.handleRefreshWorkbench}
        onValidate={this.handleOpenValidationDialog}
        onPublish={this.props.onPublish ? this.handlePublish : undefined}
        onViewAllIssues={this.handleViewAllIssues}
        onViewImportIssues={this.handleViewImportIssues}
        onViewImportRecords={this.handleViewImportRecords}
        onOpenIssueRecord={this.handleOpenIssueRecord}
      />
    );
  }

  /* ==========================================================
   * Staging tab
   * ==========================================================
   */

  // private renderStagingTab(): React.ReactNode {
  //   return (
  //     //{
  //     // this.state.activeTab === 'staging' && (
  //     <BieOnboardingWorkbenchStaging
  //       review={this.state.stagingReview}
  //       loading={this.state.loadingStagingReview}
  //       refreshing={this.state.refreshingStagingReview}
  //       disabled={this.state.staging || this.state.validating}
  //       onRefresh={this.handleRefreshStagingReview}
  //       onOpenImportRecords={this.handleOpenImportRecords}
  //     />
  //     //)
  //     //}
  //   );
  // }

  private renderStagingTab(): React.ReactNode {
    return (
      <Stack spacing={2}>
        {this.state.stagingErrorMessage && (
          <Alert
            severity="error"
            onClose={() =>
              this.setState({
                stagingErrorMessage: '',
              })
            }
          >
            {this.state.stagingErrorMessage}
          </Alert>
        )}

        <BieOnboardingWorkbenchStaging
          review={this.state.stagingReview}
          loading={this.state.loadingStagingReview}
          refreshing={this.state.refreshingStagingReview}
          disabled={this.state.loading || this.state.validating}
          onRefresh={this.handleRefreshStagingReview}
          onOpenImportRecords={this.handleOpenStagedImportRecords}
        />
      </Stack>
    );
  }

  /* ==========================================================
   * Imports tab
   * ==========================================================
   */

  private renderImportsTab(): React.ReactNode {
    const { workbench, loading, refreshing, selectedImportId } = this.state;

    if (loading && !workbench) {
      return this.renderTabLoading('Loading workbook imports…');
    }

    if (!workbench) {
      return this.renderTabUnavailable();
    }

    return (
      <Stack spacing={2}>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
          }}
        >
          <Stack
            direction={{
              xs: 'column',
              sm: 'row',
            }}
            justifyContent="space-between"
            alignItems={{
              xs: 'stretch',
              sm: 'center',
            }}
            spacing={1}
          >
            <Box>
              <Typography variant="h6" fontWeight={700}>
                Workbook Imports
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Review staged records and validation outcomes for each uploaded
                worksheet.
              </Typography>
            </Box>

            <Stack direction="row" spacing={1} alignItems="center">
              <BieOnboardingStatusChip
                kind="READINESS"
                value={workbench.summary.validationReady}
              />

              <Tooltip title="Refresh Imports" arrow>
                <span>
                  <IconButton
                    disabled={refreshing || this.state.validating}
                    onClick={this.handleRefreshWorkbench}
                  >
                    <RefreshOutlinedIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Stack>
        </Paper>

        {workbench.imports.length === 0 ? (
          <Paper
            variant="outlined"
            sx={{
              py: 7,
              px: 3,
              textAlign: 'center',
            }}
          >
            <DatasetOutlinedIcon
              color="disabled"
              sx={{
                fontSize: 52,
              }}
            />

            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                mt: 1,
              }}
            >
              No workbook imports found
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.75,
              }}
            >
              The selected Load Session does not contain active staged worksheet
              imports.
            </Typography>
          </Paper>
        ) : (
          <Grid container spacing={2}>
            {workbench.imports.map((item) => (
              <Grid size={{ xs: 12, md: 6, xl: 4 }} key={String(item.rid)}>
                <BieOnboardingImportCard
                  data={item}
                  selected={String(selectedImportId) === String(item.rid)}
                  disabled={this.state.validating || this.state.publishing}
                  onClick={this.handleSelectImport}
                  onViewIssues={this.handleViewImportIssues}
                  onViewRecords={this.handleViewImportRecords}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Stack>
    );
  }

  /* ==========================================================
   * Issues tab
   * ==========================================================
   */

  private renderIssuesTab(): React.ReactNode {
    const workbench = this.state.workbench;

    return (
      <BieOnboardingIssueGrid
        issues={this.state.issues}
        imports={workbench?.imports || []}
        severities={workbench?.lookups.severities || []}
        rules={workbench?.lookups.rules || []}
        filters={this.state.filters}
        loading={this.state.issuesLoading && this.state.issues.length === 0}
        refreshing={this.state.issuesLoading && this.state.issues.length > 0}
        errorMessage={
          this.state.selectedTab === 'ISSUES' ? this.state.errorMessage : ''
        }
        selectedIssueId={this.state.selectedIssueId}
        pageOffset={this.state.issuePageOffset}
        pageLimit={this.state.issuePageLimit}
        hasNextPage={this.state.issues.length >= this.state.issuePageLimit}
        onFiltersChange={this.handleIssueFiltersChange}
        onApplyFilters={this.handleApplyIssueFilters}
        onClearFilters={this.handleClearIssueFilters}
        onRefresh={this.handleRefreshIssues}
        onPageChange={this.handleIssuePageChange}
        onPageLimitChange={this.handleIssuePageLimitChange}
        onSelectIssue={this.handleSelectIssue}
        onOpenRecord={this.handleOpenIssueRecord}
      />
    );
  }

  /* ==========================================================
   * Rules tab
   * ==========================================================
   */

  private renderRulesTab(): React.ReactNode {
    return (
      <BieOnboardingRuleGrid
        rules={this.state.rules}
        issueSummaries={this.state.workbench?.summary.byRule || []}
        severities={this.state.workbench?.lookups.severities || []}
        loading={this.state.rulesLoading && this.state.rules.length === 0}
        refreshing={this.state.rulesLoading && this.state.rules.length > 0}
        errorMessage={
          this.state.selectedTab === 'RULES' ? this.state.errorMessage : ''
        }
        selectedRuleId={this.state.selectedRuleId}
        onRefresh={this.handleRefreshRules}
        onSelectRule={this.handleSelectRule}
        onViewRuleIssues={this.handleViewRuleIssues}
      />
    );
  }

  /* ==========================================================
   * Workbench loading
   * ==========================================================
   */

  private async loadWorkbench(initialLoad = false): Promise<void> {
    const requestVersion = ++this.workbenchRequestVersion;

    this.safeSetState({
      loading: initialLoad,

      refreshing: !initialLoad,

      errorMessage: '',
    });

    try {
      //const workbench = await this.api.getWorkbench(this.props.loadSessionId);
      const loadSessionId = this.resolveLoadSessionId();

      if (!loadSessionId || Number(loadSessionId) <= 0) {
        throw new Error(
          'The onboarding Workbench requires a valid Load Session ID.'
        );
      }

      if (String(this.state.loadSessionId) !== String(loadSessionId)) {
        this.safeSetState({ loadSessionId });
      }

      const workbench = await fetchBieOnboardingWorkbench(loadSessionId);

      if (!this.mounted || requestVersion !== this.workbenchRequestVersion) {
        return;
      }

      this.setState(
        {
          workbench,

          loading: false,
          refreshing: false,

          errorMessage: '',

          /*
           * Keep the issue list synchronized when the validation
           * result contains no current issues.
           */
          issues: workbench.summary.issues.total > 0 ? this.state.issues : [],

          selectedIssueId:
            workbench.summary.issues.total > 0
              ? this.state.selectedIssueId
              : '',
        },
        () => {
          this.props.onWorkbenchChange?.(workbench);
        }
      );
    } catch (error) {
      if (!this.mounted || requestVersion !== this.workbenchRequestVersion) {
        return;
      }

      this.setState({
        loading: false,
        refreshing: false,

        errorMessage: this.getErrorMessage(error),
      });
    }
  }

  /* ==========================================================
   * Staging loading
   * ==========================================================
   */
  private async loadStagingReview(
    refreshing = false,
  ): Promise<void> {
    const loadSessionId =
      this.resolveLoadSessionId();

    if (!loadSessionId) {
      this.setState({
        loadingStagingReview: false,
        refreshingStagingReview: false,
        stagingErrorMessage:
          'A Load Session is required to load staging results.',
      });

      return;
    }

    this.setState({
      loadingStagingReview: !refreshing,
      refreshingStagingReview: refreshing,
      stagingErrorMessage: '',
    });

    try {
      const review = await reviewBieOnboardingWorkbook(Number(loadSessionId));

      if (!this.mounted) {
        return;
      }

      this.setState({
        stagingReview: review as IBieOnboardingWorkbenchStagingData,
        loadingStagingReview: false,
        refreshingStagingReview: false,
      });

      if (review.stamp) {
        const setWorkbenchParam = this.props.onParam('set');
        setWorkbenchParam('stp',review.stamp);
      }
    } catch (error) {
      if (!this.mounted) {
        return;
      }

      this.setState({
        loadingStagingReview: false,
        refreshingStagingReview: false,
        stagingErrorMessage: this.getErrorMessage(error),
      });
    }
  }

  /* ==========================================================
   * Issue loading
   * ==========================================================
   */

  private async loadValidationIssues(): Promise<void> {
    const requestVersion = ++this.issueRequestVersion;

    this.safeSetState({
      issuesLoading: true,
      errorMessage: '',
    });

    try {
      const { filters, issuePageOffset, issuePageLimit } = this.state;

      //const issues = await this.api.findValidationIssues({
      const issues = await fetchBieOnboardingValidationIssues({
        loadSessionId: this.resolveLoadSessionId(),

        importId: filters.importId || null,

        severityCode: filters.severityCode || null,

        ruleCode: filters.ruleCode || null,

        classCode: filters.classCode || null,

        blocking: filters.blocking === '' ? null : Number(filters.blocking),

        search: filters.search || null,

        status: 1,

        pageOffset: issuePageOffset,

        pageLimit: issuePageLimit,
      });

      if (!this.mounted || requestVersion !== this.issueRequestVersion) {
        return;
      }

      this.setState({
        issues,
        issuesLoading: false,
        errorMessage: '',
      });
    } catch (error) {
      if (!this.mounted || requestVersion !== this.issueRequestVersion) {
        return;
      }

      this.setState({
        issuesLoading: false,

        errorMessage: this.getErrorMessage(error),
      });
    }
  }

  /* ==========================================================
   * Rule loading
   * ==========================================================
   */

  private async loadValidationRules(): Promise<void> {
    const requestVersion = ++this.ruleRequestVersion;

    this.safeSetState({
      rulesLoading: true,
      errorMessage: '',
    });

    try {
      //const rules = await this.api.findValidationRules({
      const rules = await fetchBieOnboardingValidationRules({
        status: 1,
      });

      if (!this.mounted || requestVersion !== this.ruleRequestVersion) {
        return;
      }

      this.setState({
        rules,
        rulesLoading: false,
        errorMessage: '',
      });
    } catch (error) {
      if (!this.mounted || requestVersion !== this.ruleRequestVersion) {
        return;
      }

      this.setState({
        rulesLoading: false,

        errorMessage: this.getErrorMessage(error),
      });
    }
  }

  /* ==========================================================
   * Validation
   * ==========================================================
   */

  private readonly handleOpenValidationDialog = (): void => {
    const workbench = this.state.workbench;

    if (!workbench) {
      return;
    }

    if (!workbench.actions.canValidate && !workbench.actions.canRevalidate) {
      this.setState({
        errorMessage:
          'The current Load Session is not available for validation.',
      });

      return;
    }

    this.setState({
      validationDialogOpen: true,
    });
  };

  private readonly handleCloseValidationDialog = (): void => {
    if (this.state.validating) {
      return;
    }

    this.setState({
      validationDialogOpen: false,
    });
  };

  // private readonly handleConfirmValidation0 = async (): Promise<void> => {
  //   const workbench = this.state.workbench;

  //   if (!workbench) {
  //     return;
  //   }

  //   this.setState({
  //     validating: true,
  //     errorMessage: '',
  //     successMessage: '',
  //   });

  //   try {
  //     //const result = await this.api.validateWorkbook(this.props.loadSessionId, {
  //     const result = await validateBieOnboardingWorkbook(this.props.params?.loadSessionId,workbench.loadSession.stamp );

  //     if (!this.mounted) {
  //       return;
  //     }

  //     const nextWorkbench = result.workbench;
  //     const rejected = String(result.validation.state).toUpperCase() === 'REJECTED';

  //     this.setState(
  //       {
  //         workbench: nextWorkbench,
  //         validating: false,
  //         validationDialogOpen: false,
  //         successMessage: rejected
  //           ? 'Validation completed. Blocking issues require correction.'
  //           : 'The onboarding workbook passed validation.',
  //         errorMessage: '',
  //         selectedTab: rejected ? 'ISSUES' : 'OVERVIEW',
  //         filters: rejected
  //           ? {
  //               ...emptyBieOnboardingWorkbenchFilters,
  //               blocking: '1',
  //             }
  //           : {
  //               ...this.state.filters,
  //             },

  //         issuePageOffset: 0,
  //         issues: rejected ? this.state.issues : [],
  //         selectedIssueId: '',
  //       },
  //       () => {
  //         this.props.onWorkbenchChange?.(nextWorkbench);
  //         if (rejected) {
  //           void this.loadValidationIssues();
  //         }
  //       }
  //     );
  //   } catch (error) {
  //     if (!this.mounted) {
  //       return;
  //     }

  //     this.setState({
  //       validating: false,
  //       validationDialogOpen: false,

  //       errorMessage: this.getErrorMessage(error),
  //     });
  //   }
  // };

  // Inside BieOnboardingWorkbench:
  private handleConfirmValidation = async (): Promise<void> => {
    const loadSessionId = this.resolveLoadSessionId();
    const stamp =
      this.state.workbench?.loadSession?.stamp ?? this.props.params?.stp;

    if (!loadSessionId || !stamp) {

      if(this.props.showNotification){
        this.props.showNotification('A valid Load Session and concurrency stamp are required','error');
      }

      this.setState({
        errorMessage:
          'A valid Load Session and concurrency stamp are required.',
      });
      return;
    }

    //
    const workbench = this.state.workbench;
    if (!workbench) {
      return;
    }

    this.setState({
      validating: true,
      errorMessage: '',
      successMessage: '',
    });

    try {
      const result = await validateBieOnboardingReview(loadSessionId, stamp);
      if (!this.mounted) {
        return;
      }
      // The returned Workbench replaces every display area affected by validation:
      // loadSession, actions, summary, imports, recentIssues and lookups.
      this.setState({
        validating: false,
        workbench: result.workbench,
      });

      // Preserve the new concurrency stamp for subsequent first-class page actions.
      this.props.onParam('set')('stp', result.validation.stamp);

      if (this.props.showNotification) {
        this.props.showNotification(result.validation.message, result.validation.valid ? 'success' : 'warning');
      }
      // this.props.showNotification?.(
      //   result.validation.message,
      //   result.validation.valid ? 'success' : 'warning',
      // );
      const nextWorkbench = result.workbench;
      const rejected =
        String(result.validation.state).toUpperCase() === 'REJECTED';

      this.setState(
        {
          workbench: nextWorkbench,
          validating: false,
          validationDialogOpen: false,
          successMessage: rejected
            ? 'Validation completed. Blocking issues require correction.'
            : 'The onboarding workbook passed validation.',
          errorMessage: '',
          selectedTab: rejected ? 'ISSUES' : 'OVERVIEW',
          filters: rejected
            ? {
                ...emptyBieOnboardingWorkbenchFilters,
                blocking: '1',
              }
            : {
                ...this.state.filters,
              },

          issuePageOffset: 0,
          issues: rejected ? this.state.issues : [],
          selectedIssueId: '',
        },
        () => {
          this.props.onWorkbenchChange?.(nextWorkbench);
          if (rejected) {
            void this.loadValidationIssues();
          }
        }
      );
    } catch (error) {
      if (!this.mounted) {
        return;
      }

      this.setState({
        validating: false,
        validationDialogOpen: false,

        errorMessage: this.getErrorMessage(error),
      });
      //this.setState({ validating: false });

      
      // this.props.showNotification?.(
      //   error instanceof Error ? error.message : 'Review validation failed.',
      //   'error',
      // );
      if (this.props.showNotification) {
        this.props.showNotification('A valid Load Session and concurrency stamp are required', 'error');
      }
    }
  };

  // Inside BieOnboardingWorkbench:
  // private validateReview = async (): Promise<void> => {
  //   const loadSessionId = this.resolveLoadSessionId();
  //   const stamp =
  //     this.state.workbench?.loadSession?.stamp ?? this.props.params?.stp;

  //   if (!loadSessionId || !stamp) {
  //     // this.props.showNotification?(
  //     //   'A valid Load Session and concurrency stamp are required.',
  //     //   'error',
  //     // );
  //     return;
  //   }

  //   this.setState({ validating: true });

  //   try {
  //     const result = await validateBieOnboardingReview(loadSessionId, stamp);

  //     // The returned Workbench replaces every display area affected by validation:
  //     // loadSession, actions, summary, imports, recentIssues and lookups.
  //     this.setState({
  //       validating: false,
  //       workbench: result.workbench,
  //     });

  //     // Preserve the new concurrency stamp for subsequent first-class page actions.
  //     this.props.onParam('set')('stp', result.validation.stamp);

  //     // this.props.showNotification?.(
  //     //   result.validation.message,
  //     //   result.validation.valid ? 'success' : 'warning',
  //     // );
  //   } catch (error) {
  //     this.setState({ validating: false });

  //     // this.props.showNotification?.(
  //     //   error instanceof Error ? error.message : 'Review validation failed.',
  //     //   'error',
  //     // );
  //   }
  // };

  private renderValidationDialog(): React.ReactNode {
    const workbench = this.state.workbench;

    const revalidation = Boolean(workbench?.actions.canRevalidate);

    return (
      <Dialog
        open={this.state.validationDialogOpen}
        onClose={this.handleCloseValidationDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {revalidation
            ? 'Revalidate Onboarding Workbook'
            : 'Validate Onboarding Workbook'}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            {revalidation
              ? 'The validation engine will clear the previous ' +
                'validation findings, resolve the corrected staged ' +
                'records and apply all active rules again.'
              : 'The validation engine will resolve controlled ' +
                'references and apply all active business, period, ' +
                'unit and reconciliation rules.'}
          </DialogContentText>

          {workbench && (
            <Alert
              severity="info"
              sx={{
                mt: 2,
              }}
            >
              {this.formatNumber(workbench.summary.items.total)}
              {' staged record(s) across '}
              {this.formatNumber(workbench.imports.length)}
              {' workbook import(s) will be evaluated.'}
            </Alert>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            color="inherit"
            disabled={this.state.validating}
            onClick={this.handleCloseValidationDialog}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color={revalidation ? 'warning' : 'primary'}
            disabled={this.state.validating}
            startIcon={
              this.state.validating ? (
                <CircularProgress size={18} />
              ) : (
                <FactCheckOutlinedIcon />
              )
            }
            onClick={this.handleConfirmValidation}
          >
            {this.state.validating
              ? 'Validating…'
              : revalidation
                ? 'Revalidate'
                : 'Validate'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  /* ==========================================================
   * Publication callback
   * ==========================================================
   */

  private readonly handlePublish = async (): Promise<void> => {
    const { onPublish } = this.props;

    const workbench = this.state.workbench;

    if (!onPublish || !workbench || !workbench.actions.canPublish) {
      return;
    }

    this.setState({
      publishing: true,
      errorMessage: '',
      successMessage: '',
    });

    try {
      //await onPublish(this.props.loadSessionId, workbench.loadSession.stamp);
      await onPublish(this.state.loadSessionId, workbench.loadSession.stamp);

      if (!this.mounted) {
        return;
      }

      this.setState({
        publishing: false,

        successMessage:
          'The validated onboarding data was published successfully.',
      });

      await this.loadWorkbench(false);
    } catch (error) {
      if (!this.mounted) {
        return;
      }

      this.setState({
        publishing: false,

        errorMessage: this.getErrorMessage(error),
      });
    }
  };

  /* ==========================================================
   * Tab handlers
   * ==========================================================
   */

  private readonly handleTabChange = (
    _event: React.SyntheticEvent,
    value: BieOnboardingWorkbenchTab
  ): void => {
    this.setState(
      {
        selectedTab: value,
        errorMessage: '',
      },
      () => {
        if (value === 'ISSUES' && this.state.issues.length === 0) {
          void this.loadValidationIssues();
        }

        if (value === 'RULES' && this.state.rules.length === 0) {
          void this.loadValidationRules();
        }

        if (value === 'STAGING' && !this.state.stagingReview && !this.state.loadingStagingReview) {
          void this.loadStagingReview(); 
        }
      }
    );
  };
  
  private readonly handleViewAllIssues = (): void => {
    this.setState(
      {
        selectedTab: 'ISSUES',

        filters: {
          ...emptyBieOnboardingWorkbenchFilters,
        },

        issuePageOffset: 0,
        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  /* ==========================================================
   * Staging handlers
   * ==========================================================
   */

  private readonly handleRefreshStagingReview =
    (): void => {
      void this.loadStagingReview(true);
    };

  private readonly handleOpenStagedImportRecords =
    (
      importId: BieRecordId,
      item: IBieOnboardingStagedImportSummary,
    ): void => {
      const loadSessionId =
        this.resolveLoadSessionId();

      if (!loadSessionId || !importId) {
        this.setState({
          stagingErrorMessage:
            'The Load Session and Import are required.',
        });

        return;
      }

      const setImportRecordsParam =
        this.props.onParam(
          'set',
        );

      setImportRecordsParam(
        'loadsessionid',
        loadSessionId,
      );

      setImportRecordsParam(
        'importid',
        importId,
      );

      setImportRecordsParam(
        'importclasscode',
        item.classCode,
      );

      setImportRecordsParam(
        'sheetname',
        item.sheetName,
      );

      setImportRecordsParam(
        'returnpage',
        'bieonboardingworkbench',
      );

      setImportRecordsParam(
        'returntab',
        'staging',
      );

      this.props.setPage(
        PAGE_IMPORT_RECORDS,
      );
    };

  private readonly handleCompleteStaging = async (): Promise<void> => {
      const workbench = this.state.workbench;

      if (!workbench) {
        return;
      }

      const loadSessionId = workbench.loadSession.rid; //loadSessionId;

      const stamp = workbench.loadSession.stamp;

      if (!loadSessionId) {
        // this.props.showNotification(
        //   'error',
        //   'Load Session ID is required.',
        // );
        if (this.props.showNotification) {
          this.props.showNotification('Load Session ID is required.', 'error');
        }

        return;
      }

      if (!stamp) {
        // this.props.showNotification(
        //   'error',
        //   'Load Session concurrency stamp is required.',
        // );
        if (this.props.showNotification) {
          this.props.showNotification('Load Session concurrency stamp is required.', 'error');
        }

        return;
      }

      this.setState({
        staging: true,
      });

      try {
        const result = await stageBieLoadSession({loadSessionId:Number(loadSessionId),stamp});

        // this.props.showNotification(
        //   'success',
        //   `Load Session staged successfully. ${result.importCount} active import${result.importCount === 1 ? '' : 's'} confirmed.`,
        // );
        if (this.props.showNotification) {
          const c = result.importCount === 1 ? '' : 's'
          const notmessage = `Load Session staged successfully. ${result.importCount} active import${c} confirmed.`
          this.props.showNotification(notmessage, 'success');
        }

        await this.loadWorkbench();

        await this.loadStagingReview(true);
      } catch (error) {
        // this.props.showNotification(
        //   'error',
        //   this.getErrorMessage(
        //     error,
        //   ),
        // );
        if (this.props.showNotification) {
          this.props.showNotification(this.getErrorMessage(error), 'error');
        }
      } finally {
        if (this.mounted) {
          this.setState({
            staging: false,
          });
        }
      }
    };

  /* ==========================================================
   * Import handlers
   * ==========================================================
   */

  private readonly handleSelectImport = (importId: BieRecordId): void => {
    this.setState({
      selectedImportId: importId,
    });
  };

  private readonly handleViewImportIssues = (
    importId: BieRecordId,
    _data: IBieOnboardingWorkbenchImport
  ): void => {
    this.setState(
      {
        selectedImportId: importId,

        selectedTab: 'ISSUES',

        filters: {
          ...emptyBieOnboardingWorkbenchFilters,

          importId,
        },

        issuePageOffset: 0,

        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  private readonly handleViewImportRecords = (
    importId: BieRecordId,
    data: IBieOnboardingWorkbenchImport
  ): void => {
    this.setState({
      selectedImportId: importId,
    });

    if (this.props.onOpenImportRecords) {
      this.props.onOpenImportRecords(importId, data);
      return;
    }

    const setParam = this.props.onParam('set');
    const unsetParam = this.props.onParam('unset');
    unsetParam('importitemid', null);
    setParam('loadsessionid', this.resolveLoadSessionId());
    setParam('importid', importId);
    setParam('importcode', data.code || null);
    setParam('importname', data.name || null);
    setParam('sheetname', data.sheetName || null);
    setParam('classcode', data.classCode || null);
    setParam('stp', this.state.workbench?.loadSession.stamp || null);
    this.props.setPage(PAGE_IMPORT_RECORDS);
  };

  /* ==========================================================
   * Issue handlers
   * ==========================================================
   */

  private readonly handleIssueFiltersChange = (
    filters: IBieOnboardingWorkbenchFilters
  ): void => {
    this.setState({
      filters,
    });
  };

  private readonly handleApplyIssueFilters = (): void => {
    this.setState(
      {
        issuePageOffset: 0,
        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  private readonly handleClearIssueFilters = (): void => {
    this.setState(
      {
        filters: {
          ...emptyBieOnboardingWorkbenchFilters,
        },

        issuePageOffset: 0,
        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  private readonly handleRefreshIssues = (): void => {
    void this.loadValidationIssues();
  };

  private readonly handleIssuePageChange = (pageOffset: number): void => {
    this.setState(
      {
        issuePageOffset: pageOffset,

        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  private readonly handleIssuePageLimitChange = (pageLimit: number): void => {
    this.setState(
      {
        issuePageLimit: pageLimit,

        issuePageOffset: 0,

        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  private readonly handleSelectIssue = (
    issue: IBieOnboardingValidationIssue
  ): void => {
    this.setState({
      selectedIssueId: issue.rid,
    });
  };

  private readonly handleOpenIssueRecord = (
    importItemId: BieRecordId,
    issue: IBieOnboardingValidationIssue
  ): void => {
    this.setState({
      selectedIssueId: issue.rid,
    });

    if (this.props.onOpenImportItem) {
      this.props.onOpenImportItem(importItemId, issue);
      return;
    }

    const setParam = this.props.onParam('set');
    setParam('loadsessionid', this.resolveLoadSessionId());
    setParam('importid', issue.imi || this.state.selectedImportId || null);
    setParam('importitemid', importItemId);
    setParam('stp', this.state.workbench?.loadSession.stamp || null);
    this.props.setPage(PAGE_IMPORT_ITEM);
  };

  /* ==========================================================
   * Rule handlers
   * ==========================================================
   */

  private readonly handleRefreshRules = (): void => {
    void this.loadValidationRules();
  };

  private readonly handleSelectRule = (
    rule: IBieOnboardingValidationRule
  ): void => {
    this.setState({
      selectedRuleId: rule.rid,
    });
  };

  private readonly handleViewRuleIssues = (
    ruleCode: string,
    rule: IBieOnboardingValidationRule
  ): void => {
    this.setState(
      {
        selectedRuleId: rule.rid,

        selectedTab: 'ISSUES',

        filters: {
          ...emptyBieOnboardingWorkbenchFilters,

          ruleCode,
        },

        issuePageOffset: 0,

        selectedIssueId: '',
      },
      () => {
        void this.loadValidationIssues();
      }
    );
  };

  /* ==========================================================
   * Refresh
   * ==========================================================
   */

  private readonly handleRefreshWorkbench = (): void => {
    void this.loadWorkbench(false);
  };

  /* ==========================================================
   * Notifications
   * ==========================================================
   */

  private renderNotifications(): React.ReactNode {
    return (
      <>
        <Snackbar
          open={Boolean(this.state.successMessage)}
          autoHideDuration={6000}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          onClose={this.handleCloseSuccessMessage}
        >
          <Alert
            severity="success"
            variant="filled"
            onClose={this.handleCloseSuccessMessage}
            sx={{
              width: '100%',
            }}
          >
            {this.state.successMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={
            Boolean(this.state.errorMessage) &&
            this.state.selectedTab !== 'OVERVIEW' &&
            this.state.selectedTab !== 'ISSUES' &&
            this.state.selectedTab !== 'RULES'
          }
          autoHideDuration={8000}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          onClose={this.handleCloseErrorMessage}
        >
          <Alert
            severity="error"
            variant="filled"
            onClose={this.handleCloseErrorMessage}
            sx={{
              width: '100%',
            }}
          >
            {this.state.errorMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }

  private readonly handleCloseSuccessMessage = (): void => {
    this.setState({
      successMessage: '',
    });
  };

  private readonly handleCloseErrorMessage = (): void => {
    this.setState({
      errorMessage: '',
    });
  };

  /* ==========================================================
   * State reset
   * ==========================================================
   */

  private resetForLoadSessionChange(loadSessionId: BieRecordId): void {
    this.workbenchRequestVersion += 1;
    this.issueRequestVersion += 1;
    this.ruleRequestVersion += 1;

    this.setState({
      ...emptyBieOnboardingWorkbenchState,

      issuesLoading: false,
      rulesLoading: false,
      publishing: false,

      validationDialogOpen: false,

      selectedImportId: '',
      selectedIssueId: '',
      selectedRuleId: '',
      loadSessionId,
    });
  }

  /* ==========================================================
   * Generic display states
   * ==========================================================
   */

  private renderTabLoading(message: string): React.ReactNode {
    return (
      <Paper
        variant="outlined"
        sx={{
          py: 8,
          px: 3,
          textAlign: 'center',
        }}
      >
        <CircularProgress />

        <Typography
          variant="body1"
          fontWeight={600}
          sx={{
            mt: 2,
          }}
        >
          {message}
        </Typography>
      </Paper>
    );
  }

  private renderTabUnavailable(): React.ReactNode {
    return (
      <Paper
        variant="outlined"
        sx={{
          py: 8,
          px: 3,
          textAlign: 'center',
        }}
      >
        <AssessmentOutlinedIcon
          color="disabled"
          sx={{
            fontSize: 52,
          }}
        />

        <Typography
          variant="h6"
          fontWeight={700}
          sx={{
            mt: 1,
          }}
        >
          Workbench data unavailable
        </Typography>

        <Button
          variant="outlined"
          startIcon={<RefreshOutlinedIcon />}
          sx={{
            mt: 2,
          }}
          onClick={this.handleRefreshWorkbench}
        >
          Retry
        </Button>
      </Paper>
    );
  }

  /* ==========================================================
   * Helpers
   * ==========================================================
   */

  private safeSetState(
    state: Partial<IBieOnboardingWorkbenchComponentState>
  ): void {
    if (!this.mounted) {
      return;
    }

    this.setState(
      state as Pick<
        IBieOnboardingWorkbenchComponentState,
        keyof IBieOnboardingWorkbenchComponentState
      >
    );
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof BieOnboardingApiError) {
      if (error.statusCode === 409) {
        return (
          'The Load Session was changed by another operation. ' +
          'Refresh the Workbench and try again.'
        );
      }

      return error.message;
    }

    if (error instanceof Error) {
      return error.message;
    }

    return (
      'An unexpected error occurred while processing the ' +
      'Onboarding Workbench request.'
    );
  }

  private formatNumber(value: unknown): string {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
      return '0';
    }

    return new Intl.NumberFormat().format(numericValue);
  }
}
